/* eslint-disable array-callback-return */

export default class SharedNodesCluster {
    //Public:
    constructor(nodes) {
        this._allNodesObject = nodes;
        this.defineProperties();
    }

    compute(indices) {
        this.nodesIndices = indices;
        this.forcibleNodesIndices = indices;
        this.getNodes(indices);
        this.getClusters();
    }

    // Private:
    getNodes(indices) {
        let nodes = [];
        let allNodesObject = this._allNodesObject;
        indices.forEach(index => {
            let node = allNodesObject[index];
            nodes.push(node);
        });
        this._nodesObjects = nodes;
    }

    getClusters() {
        this._clusters = [];
        this._clustersIds = [];
        let nodes = this._nodesObjects;
        nodes.forEach(node => {
            const thisNodeClusters = node.clusters;
            thisNodeClusters.forEach(cluster => {
                let id = cluster.id;
                if (this.isClusterNew(id)) {
                    this._clustersIds.push(id);
                    this._clusters.push(cluster);
                }
            });
        });
    }

    defineProperties() {
        this.defineGetterX();
        this.defineGetterY();
        this.defineGetterRadius();
    }

    defineGetterX() {
        let getFunc = () => this.computeX();
        Object.defineProperty(this, "x", {get: getFunc});
    }

    defineGetterY() {
        let getFunc = () => this.computeY();
        Object.defineProperty(this, "y", {get: getFunc});
    }

    defineGetterRadius() {
        let getFunc = () => this.computeRadius();
        Object.defineProperty(this, "sharedRadius", {get: getFunc});
    }

    computeRadius() {
        if (this.isSingleNoded()) return 0;
        else {
            let k = 3.0;
            let perimeter = this.computePerimeter();
            let R = perimeter / (2 * Math.PI);
            R = k * R;
            return R;
        }
    }

    computePerimeter() {
        let indices = this.nodesIndices;
        let p = 0;
        this._allNodesObject.find(node => {
            const isNodeInCluster = indices.indexOf(node.number) !== -1;
            if (isNodeInCluster) {
                let R = node.radius;
                p = p + 2 * R;
            }
        });
        return p;
    }

    computeX() {
        let X = this.getClustersProperty("x");
        let R = this.getClustersProperty("radius");
        let x = this.computeInverseMean(X, R);
        return x;
    }

    computeY() {
        let Y = this.getClustersProperty("y");
        let R = this.getClustersProperty("radius");
        let y = this.computeInverseMean(Y, R);
        return y;
    }

    getClustersProperty(prop) {
        let array = [];
        let clusters = this._clusters;
        clusters.forEach(cluster => {
            array.push(cluster[prop]);
        });
        return array;
    }

    computeInverseMean(values, weights) {
        let invW = 0;
        let sum = 0;
        values.forEach((fi, i) => {
            const wi = weights[i];
            sum += fi / wi;
            invW += 1 / wi;
        });
        let W = 1 / invW;
        let F = W * sum;
        return F;
    }

    isClusterNew(id) {
        if (this._clustersIds.indexOf(id) === -1) return true;
        else return false;
    }

    isSingleNoded() {
        if (this.nodesIndices.length === 1) return true;
        else return false;
    }
}
